'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectors = exports.reducer = exports.actions = undefined;

var _handleActions, _handleActions2;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _contract = require('./contract');

var _contract2 = _interopRequireDefault(_contract);

var _reduxActions = require('redux-actions');

var _websockets = require('@rushplay/websockets');

var websockets = _interopRequireWildcard(_websockets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function fieldPath(form, field) {
  (0, _contract2.default)('form', String, form);
  (0, _contract2.default)('field', String, field);

  return [form, 'fields', field];
}

function fieldPathMeta(form, field) {
  return { path: fieldPath(form, field) };
}

/**
 * @deprecated
 * @param {string} form - Form name
 * @param {string} field - Field name
 * @param {boolean} [required=false] - Mark field as required
 * @param {string} [initialValue] - Add initial value
 * @param {string} [group] - Field's group
 * @returns {object} - 'forms/REGISTER' action
 */
function register__DEPRECATED(form, field) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var initialValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var group = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

  return {
    type: 'forms/REGISTER',
    meta: fieldPathMeta(form, field),
    payload: {
      initialValue: initialValue,
      group: group,
      required: required,
      value: value
    }
  };
}

/**
 * @deprecated
 * @param {string} form - Form name
 * @param {string} field - Field name
 * @param {(boolean|string)} status - Field validation status
 * @param {string[]} [errors] - Validation errors
 * @returns {object} - 'forms/VALIDATE' action
 */
function validate__DEPRECATED(form, field, status, errors) {
  return {
    type: 'forms/VALIDATE',
    meta: fieldPathMeta(form, field),
    payload: {
      status: statusAsString(status),
      errors: errorsAsArray(errors)
    }
  };
}

var statusAsString = R.cond([[R.equals(true), R.always('valid')], [R.equals(false), R.always('invalid')], [R.T, R.identity]]);

var errorsAsArray = R.pipe(R.unless(R.is(Array), R.of), R.reject(R.isNil));

var actions = exports.actions = {
  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @returns {object} - 'forms/BLUR' action
   */
  blur: function blur(form, field) {
    return {
      type: 'forms/BLUR',
      payload: fieldPath(form, field)
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @returns {object} - 'forms/CHANGE_VALUE' action
   */
  changeValue: function changeValue(form, field) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return {
      type: 'forms/CHANGE_VALUE',
      meta: fieldPathMeta(form, field),
      payload: { value: value }
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string[]} fields - Field names
   * @returns {object} - 'forms/CLEAR_FORM' action
   */
  clearFields: function clearFields(form, fields) {
    return {
      type: 'forms/CLEAR_FIELDS',
      meta: { form: form, fields: fields }
    };
  },


  /**
   * @param {string} form - Form name
   * @returns {object} - 'forms/CLEAR_FORM' action
   */
  clearForm: function clearForm(form) {
    return {
      type: 'forms/CLEAR_FORM',
      meta: { form: form }
    };
  },


  /**
   * @returns {object} - 'forms/CLEAR_FORMS' action
   */
  clearForms: function clearForms() {
    return {
      type: 'forms/CLEAR_FORMS'
    };
  },


  /**
   * @param {string} form - Form name
   * @returns {object} - 'forms/COMMIT' action
   */
  commitForm: function commitForm(form) {
    return {
      type: 'forms/COMMIT',
      payload: form
    };
  },


  /**
   * @param {string} form - Form name
   * @returns {object} - 'forms/DESTROY_FORM' action
   */
  destroyForm: function destroyForm(form) {
    (0, _contract2.default)('form', String, form);
    return {
      type: 'forms/DESTROY_FORM',
      meta: { form: form }
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @returns {object} - 'forms/FOCUS' action
   */
  focus: function focus(form, field) {
    return {
      type: 'forms/FOCUS',
      payload: fieldPath(form, field)
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @param {object} [options]
   * @param {string} [options.group] - Field's group
   * @param {string} [options.initialValue=""] - Add initial value
   * @param {boolean} [options.required=false] - Mark field as required
   * @param {string} [options.value=""] - Set value
   * @returns {object} - 'forms/REGISTER' action
   */
  register: function register(form, field, options) {
    // TODO: remove
    if (arguments.length >= 3 && typeof options === 'boolean') {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('DEPRECATED', 'passing field options as separate arguments is deprecated and will be removed; pass object instead \'register(form, field, {group, initialValue, required, value})\'');
      }
      return register__DEPRECATED.apply(null, arguments);
    }

    return {
      type: 'forms/REGISTER',
      meta: fieldPathMeta(form, field),
      payload: {
        initialValue: options && options.initialValue || '',
        group: options && options.group,
        required: options && options.required || false,
        value: options && options.value || ''
      }
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @param {object} options
   * @param {(boolean|string)} options.status - Field validation status
   * @param {string} options.value - Field value to be validated
   * @param {string[]} [options.errors] - Validation errors
   * @returns {object} - 'forms/VALIDATE' action
   */
  validate: function validate(form, field, options) {
    // TODO: remove
    if (arguments.length >= 3 && (typeof options === 'boolean' || typeof options === 'string')) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('DEPRECATED', 'passing validation options as separate arguments is deprecated and will be removed; pass object instead \'validate(form, field, {errors, status, value})\'');
      }
      return validate__DEPRECATED.apply(null, arguments);
    }

    return {
      type: 'forms/VALIDATE',
      meta: R.merge(fieldPathMeta(form, field), { value: options.value }),
      payload: {
        status: statusAsString(options.status),
        errors: errorsAsArray(options.errors)
      }
    };
  },
  validateForm: function validateForm(form, options) {
    (0, _contract2.default)('form', String, form);

    return {
      type: 'forms/VALIDATE_FORM',
      meta: { form: form },
      payload: {
        status: statusAsString(options.status),
        errors: errorsAsArray(options.errors)
      }
    };
  },


  /**
   * @param {string} form - Form name
   * @param {string} field - Field name
   * @returns {object} - 'forms/VISIT' action
   */
  visit: function visit(form, field) {
    return {
      type: 'forms/VISIT',
      meta: fieldPathMeta(form, field)
    };
  }
};

actions.blur.toString = function () {
  return 'forms/BLUR';
};
actions.changeValue.toString = function () {
  return 'forms/CHANGE_VALUE';
};
actions.clearFields.toString = function () {
  return 'forms/CLEAR_FIELDS';
};
actions.clearForm.toString = function () {
  return 'forms/CLEAR_FORM';
};
actions.clearForms.toString = function () {
  return 'forms/CLEAR_FORMS';
};
actions.commitForm.toString = function () {
  return 'forms/COMMIT';
};
actions.destroyForm.toString = function () {
  return 'forms/DESTROY_FORM';
};
actions.focus.toString = function () {
  return 'forms/FOCUS';
};
actions.register.toString = function () {
  return 'forms/REGISTER';
};
actions.validate.toString = function () {
  return 'forms/VALIDATE';
};
actions.validateForm.toString = function () {
  return 'forms/VALIDATE_FORM';
};
actions.visit.toString = function () {
  return 'forms/VISIT';
};

var combinedFieldActions = (0, _reduxActions.combineActions)(actions.changeValue, actions.register, actions.validate, actions.visit);

var combinedClearFormsActions = (0, _reduxActions.combineActions)(websockets.SESSION_EXPIRED, actions.clearForms);

var lensPropOr = function lensPropOr(fallback, name) {
  return R.lens(R.propOr(fallback, name), R.assoc(name));
};

var formLens = function formLens(form) {
  return R.compose(R.lensProp('data'), lensPropOr({}, form));
};

var formFieldsLens = function formFieldsLens(form) {
  return R.compose(formLens(form), lensPropOr({}, 'fields'));
};

var lensPathOr = function lensPathOr(fallback, path) {
  return R.lens(R.pathOr(fallback, path), R.assocPath(path));
};

var fieldLens = function fieldLens(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      form = _ref2[0],
      field = _ref2[2];

  return R.compose(formLens(form), lensPathOr({}, ['fields', field]));
};

/**
 * Commit field state
 * @param {object} Field state
 * @returns {object}
 */
var commitField = R.pipe(R.converge(R.assoc('initialValue'), [R.prop('value'), R.identity]), R.dissoc('status'), R.dissoc('visited'));

/**
 * Reset field state
 * @param {object} Field state
 * @returns {object}
 */
var resetField = R.pipe(R.dissoc('status'), R.assoc('value', ''), R.dissoc('visited'));

var fieldReducer = R.curry((0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, actions.changeValue, function (state, _ref3) {
  var payload = _ref3.payload;
  return R.pipe(R.assoc('value', payload.value), R.unless(R.prop('visited'), R.assoc('visited', true)))(state);
}), _defineProperty(_handleActions, actions.register, function (state, _ref4) {
  var payload = _ref4.payload;
  return R.pipe(R.assoc('initialValue', payload.initialValue), R.assoc('required', payload.required), R.assoc('value', payload.value || payload.initialValue || ''), R.assoc('group', payload.group))(state);
}), _defineProperty(_handleActions, actions.validate, function (state, _ref5) {
  var meta = _ref5.meta,
      payload = _ref5.payload;

  // TODO: remove
  var isDeprecatedAction = typeof meta.value === 'undefined';

  if (isDeprecatedAction || meta.value === state.value) {
    return R.pipe(R.assoc('status', payload.status), R.assoc('errors', payload.errors))(state);
  }

  return state;
}), _defineProperty(_handleActions, actions.visit, function (state) {
  return R.assoc('visited', true, state);
}), _handleActions), {}));

var reducer = exports.reducer = (0, _reduxActions.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, actions.blur, function (state, _ref6) {
  var payload = _ref6.payload;
  return R.when(R.propEq('focused', payload), R.dissoc('focused'))(state);
}), _defineProperty(_handleActions2, actions.clearFields, function (state, action) {
  return R.over(formFieldsLens(action.meta.form), R.mapObjIndexed(function (state, field) {
    if (R.contains(field, action.meta.fields)) {
      return resetField(state);
    }

    return state;
  }), state);
}), _defineProperty(_handleActions2, actions.clearForm, function (state, action) {
  return R.over(formFieldsLens(action.meta.form), R.map(resetField), state);
}), _defineProperty(_handleActions2, combinedClearFormsActions, function (state) {
  return R.dissoc('data', state);
}), _defineProperty(_handleActions2, actions.commitForm, function (state, action) {
  return R.over(formFieldsLens(action.payload), R.map(commitField), state);
}), _defineProperty(_handleActions2, actions.destroyForm, function (state, action) {
  return R.dissocPath(['data', action.meta.form], state);
}), _defineProperty(_handleActions2, actions.focus, function (state, _ref7) {
  var payload = _ref7.payload;
  return R.assoc('focused', payload, state);
}), _defineProperty(_handleActions2, combinedFieldActions, function (state, action) {
  return R.over(fieldLens(action.meta.path), function (state) {
    return fieldReducer(state, action);
  }, state);
}), _defineProperty(_handleActions2, actions.validateForm, function (state, _ref8) {
  var meta = _ref8.meta,
      payload = _ref8.payload;
  return R.over(formLens(meta.form), R.pipe(R.assoc('status', payload.status), R.assoc('errors', payload.errors)), state);
}), _handleActions2), {});

var selectors = exports.selectors = {
  isFocused: function isFocused(state, props) {
    return R.propEq('focused', [props.form, 'fields', props.field], state);
  },
  isAllFieldsHaveStatus: function isAllFieldsHaveStatus(state, props) {
    return R.pipe(R.pathOr({}, ['data', props.form, 'fields']), R.values, R.when(function () {
      return props.group;
    }, R.filter(R.propEq('group', props.group))), R.all(R.propEq('status', props.status)))(state);
  },
  isPristine: function isPristine(state, props) {
    return R.pipe(R.pathOr({}, ['data', props.form, 'fields', props.field]), R.converge(R.equals, [R.prop('initialValue'), R.prop('value')]))(state);
  },
  isRequired: function isRequired(state, props) {
    return R.path(['data', props.form, 'fields', props.field, 'required'], state);
  },
  isValid: function isValid(state, props) {
    return R.pathEq(['data', props.form, 'fields', props.field, 'status'], 'valid', state);
  },
  isVisited: function isVisited(state, props) {
    return R.pipe(R.path(['data', props.form, 'fields', props.field, 'visited']), Boolean)(state);
  },
  errors: function errors(state, props) {
    return R.path(['data', props.form, 'fields', props.field, 'errors'], state);
  },
  fields: function fields(state, props) {
    return R.pathOr({}, ['data', props.form, 'fields'], state);
  },
  formErrors: function formErrors(state, props) {
    return R.pathOr([], ['data', props.form, 'errors'], state);
  },
  status: function status(state, props) {
    return R.path(['data', props.form, 'fields', props.field, 'status'], state);
  },
  value: function value(state, props) {
    return R.pathOr('', ['data', props.form, 'fields', props.field, 'value'], state);
  }
};